import { RadioButtonWithLabelGroupWidget, RadioButtonWithLabelOption, RadioLayoutType } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';

import { DomainPermission } from '../../types/DomainPermission';

export type DomainPermissionsSelectorProps = Readonly<{
    onDomainPermissionChange: (domainPermission: DomainPermission) => void;
    domainPermission: DomainPermission;
}>;

export function DomainPermissionsSelector(props: DomainPermissionsSelectorProps) {
    const domainPermissionOptions: RadioButtonWithLabelOption<DomainPermission>[] = [
        {
            value: DomainPermission.ALLOW,
            testId: 'Allow',
            label: Messages.bridgeSiteSettingsAllow()
        },
        {
            value: DomainPermission.BLOCK,
            testId: 'Block',
            label: Messages.bridgeSiteSettingsBlock()
        },
    ];

    return (
        <RadioButtonWithLabelGroupWidget
            label={Messages.bridgeSiteSettingsDomainPermissions()}
            buttonList={domainPermissionOptions}
            checkedIndex={props.domainPermission === DomainPermission.ALLOW ? 0 : 1 }
            handleChange={props.onDomainPermissionChange}
            layout={RadioLayoutType.Veritical}
        />
    );
}
